/***************************************************************************/
"use client";
/***************************************************************************/

import { cva } from "class-variance-authority";
import * as React from "react";
import { cn } from "../../../utils/css";
import { CardContext } from "./card";

const cardTitleVariants = cva("mb-0 tracking-tight", {
  variants: {
    size: {
      default: "text-lg",
      sm: "text-base font-semibold",
      lg: "text-xl",
    },
  },
  defaultVariants: {
    size: "default",
  },
});

const cardSubtitleVariants = cva("text-foreground", {
  variants: {
    size: {
      default: "text-sm",
      sm: "text-xs",
      lg: "text-sm",
    },
  },
  defaultVariants: {
    size: "default",
  },
});

const CardTitle = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLHeadingElement>
>(({ className, ...props }, ref) => {
  const { size } = React.useContext(CardContext);

  return (
    <h5
      ref={ref}
      className={cn(cardTitleVariants({ size }), className)}
      {...props}
    />
  );
});
CardTitle.displayName = "CardTitle";

const CardSubtitle = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLParagraphElement>
>(({ className, ...props }, ref) => {
  const { size } = React.useContext(CardContext);

  return (
    <p
      ref={ref}
      className={cn(cardSubtitleVariants({ size }), className)}
      {...props}
    />
  );
});
CardSubtitle.displayName = "CardSubtitle";

export { CardSubtitle, CardTitle, cardSubtitleVariants, cardTitleVariants };
